import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_AcademicQualifications = createAsyncThunk(
  "SU_NT_MRI_AcademicQualificationsServices/GetOneSU_NT_MRI_AcademicQualifications",
  async (academicQualificationsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_AcademicQualificationsServices/GetOneSU_NT_MRI_AcademicQualifications",
        {
          academicQualificationsId: academicQualificationsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteSU_NT_MRI_AcademicQualifications = createAsyncThunk(
  "SU_NT_MRI_AcademicQualificationsServices/DeleteSU_NT_MRI_AcademicQualifications",
  async (academicQualificationsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_AcademicQualificationsServices/DeleteSU_NT_MRI_AcademicQualifications",
        {
          academicQualificationsId: academicQualificationsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateSU_NT_MRI_AcademicQualifications = createAsyncThunk(
  "SU_NT_MRI_AcademicQualificationsServices/UpdateSU_NT_MRI_AcademicQualifications",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_AcademicQualificationsServices/UpdateSU_NT_MRI_AcademicQualifications",
        {
          academicQualificationsId: model.academicQualificationsId,
          academicDegreeId: model.academicDegreeId,
          graduationYear: model.graduationYear,
          major: model.major,
          university: model.university,
          nationalityId: model.nationalityId,
          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSU_NT_MRI_AcademicQualifications = createAsyncThunk(
  "SU_NT_MRI_AcademicQualificationsServices/AddSU_NT_MRI_AcademicQualifications",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_AcademicQualificationsServices/AddSU_NT_MRI_AcademicQualifications",
        {
          academicDegreeId: model.academicDegreeId,
          graduationYear: model.graduationYear,
          major: model.major,
          university: model.university,
          nationalityId: model.nationalityId,
          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AcademicQualificationsDegree = createSlice({
  name: "AcademicQualificationsDegree",
  initialState: {
    academicQualifications: {},
    loadingacademicQualifications: false,
    erroracademicQualifications: null,

    AddacademicQualifications: {},
    loadingAddacademicQualifications: false,
    errorAddacademicQualifications: null,

    UpdateacademicQualifications: {},
    loadingUpdateacademicQualifications: false,
    errorUpdateacademicQualifications: null,

    DeleteacademicQualifications: {},
    loadingDeleteacademicQualifications: false,
    errorDeleteacademicQualifications: null,

    ListacademicQualifications: {},
    loadingListacademicQualifications: false,
    errorListacademicQualifications: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneSU_NT_MRI_AcademicQualifications.pending,
        (state, action) => {
          state.loadingacademicQualifications = true;
          state.academicQualifications = action.payload;
          state.erroracademicQualifications = null;
        }
      )
      .addCase(
        GetOneSU_NT_MRI_AcademicQualifications.fulfilled,
        (state, action) => {
          state.loadingacademicQualifications = false;
          state.academicQualifications = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneSU_NT_MRI_AcademicQualifications.rejected,
        (state, action) => {
          state.loadingacademicQualifications = false;
          state.erroracademicQualifications = action.payload;
        }
      )

      .addCase(
        DeleteSU_NT_MRI_AcademicQualifications.pending,
        (state, action) => {
          state.loadingDeleteacademicQualifications = true;
          state.DeleteacademicQualifications = action.payload;
          state.errorDeleteacademicQualifications = null;
        }
      )
      .addCase(
        DeleteSU_NT_MRI_AcademicQualifications.fulfilled,
        (state, action) => {
          state.loadingDeleteacademicQualifications = false;
          state.DeleteacademicQualifications = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteSU_NT_MRI_AcademicQualifications.rejected,
        (state, action) => {
          state.loadingDeleteacademicQualifications = false;
          state.errorDeleteacademicQualifications = action.payload;
        }
      )

      .addCase(UpdateSU_NT_MRI_AcademicQualifications.pending, (state, action) => {
        state.loadingUpdateacademicQualifications = true;
        state.UpdateacademicQualifications = action.payload;
        state.errorUpdateacademicQualifications = null;
      })
      .addCase(
        UpdateSU_NT_MRI_AcademicQualifications.fulfilled,
        (state, action) => {
          state.loadingUpdateacademicQualifications = false;
          state.UpdateacademicQualifications = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateSU_NT_MRI_AcademicQualifications.rejected, (state, action) => {
        state.loadingUpdateacademicQualifications = false;
        state.errorUpdateacademicQualifications = action.payload;
      })

      .addCase(AddSU_NT_MRI_AcademicQualifications.pending, (state, action) => {
        state.loadingAddacademicQualifications = true;
        state.AddacademicQualifications = action.payload;
        state.errorAddacademicQualifications = null;
      })
      .addCase(AddSU_NT_MRI_AcademicQualifications.fulfilled, (state, action) => {
        state.loadingAddacademicQualifications = false;
        state.AddacademicQualifications = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSU_NT_MRI_AcademicQualifications.rejected, (state, action) => {
        state.loadingAddacademicQualifications = false;
        state.errorAddacademicQualifications = action.payload;
      });
  },
});

export default AcademicQualificationsDegree.reducer;
